import { useMutation, useQueryClient } from "@tanstack/react-query";
import { enqueueSnackbar } from "notistack";

import { apiClient } from "~/api/ApiClient";
import { useSiteContext } from "~/contexts/SiteContext";

interface UseSetFocusKeywordOptions {
  siteId: number;
  onSuccess?: () => void;
}

export const useSetFocusKeyword = ({
  siteId,
  onSuccess,
}: UseSetFocusKeywordOptions) => {
  const siteContext = useSiteContext();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (keywordId: number) => {
      const response = await apiClient.sites.keywordsFocusCreate(
        siteId,
        keywordId,
      );

      return response.data;
    },
    onSuccess: () => {
      enqueueSnackbar(`The focus keyword was set successfully`, {
        variant: "success",
      });
      siteContext?.refetchSite();
      queryClient.invalidateQueries({ queryKey: ["keywordFocus"] });
      onSuccess?.();
    },
    onError: (error) => {
      enqueueSnackbar(`Error: ${error}`, { variant: "error", persist: true });
    },
  });
};
